(() => {
  // src/scripts/modules/header/animated-text.js
  var AnimatedText = class extends HTMLElement {
    constructor() {
      super();
      const Typed = window.Typed;
      if (!Typed) {
        console.warn("Typed.js is not available on window.Typed");
        return;
      }
      this.strings = Array.from(this.getAttribute("type-terms").split(",")) || [];
      const loop = this.getAttribute("type-terms-loop") || false;
      this.options = {
        strings: this.strings,
        typeSpeed: Number(this.getAttribute("type-terms-speed")) || 0,
        loop: loop === "true",
        attr: this.getAttribute("type-terms-attr") || null
      };
      this.animatedText = new Typed(this, {
        strings: this.options.strings,
        typeSpeed: this.options.typeSpeed,
        backSpeed: this.options.typeSpeed * 1.5,
        backDelay: 2e3,
        loop: this.options.loop,
        attr: this.options.attr,
        shuffle: false,
        startDelay: 100,
        onStop: (_, self) => {
          clearInterval(self.timeout);
        }
      });
    }
    connectedCallback() {
      if (!this.animatedText) {
        return;
      }
      setTimeout(() => {
        this.animatedText.start();
      }, 3e3);
    }
    disconnectedCallback() {
      if (!this.animatedText) {
        return;
      }
      this.animatedText.destroy();
    }
  };
  if (!customElements.get("animated-text")) {
    customElements.define("animated-text", AnimatedText);
  }
})();
